import * as React from 'react';
import { useAccountPositionGesEstimDExRateBuy } from '../../hooks';
import { ActorApiNumberDisplay } from '../../../../../../components/display/number/component';

export const AccountsPositionsGesEstimDExrateBuy = () => {
  const {
    data,
    isLoading,
    error,
  } = useAccountPositionGesEstimDExRateBuy();
  return (
    <ActorApiNumberDisplay
      data={data}
      isLoading={isLoading}
      error={error}
      format={{
        minimumFractionDigits: 4,
        maximumFractionDigits: 4,
      }}
    />
  );
};
